import React from 'react';
import { connect } from 'react-redux';
import { Link, Redirect } from 'react-router-dom';
import { injectIntl } from 'react-intl';
import { removeDropdown, updateVideoProgress, closeTargetAsset, setSelectedAsset, setSelectedAssetRow } from "../../redux/actions/SVOD";
import VideoPlayer from './video-player';
import PlayerControls from './player-controls';
import { PlayerType } from "./constants";
import { EnvType } from "./constants";
import loading from "../../assets/svod/appletv-icons/loading-circle.png";
import appleExitImg from '../../assets/svod/appletv-icons/x.svg';
import dolby_atmos from "../../assets/svod/appletv-icons/dolby-atmos.svg";
import dolby_vision from "../../assets/svod/appletv-icons/dolby-vision.svg";
import { convertToMinutes } from '../../functions/helpers';
import svodMessages from '../../locales/svod';
import Logger from '../../functions/logging';
import SVODSideMenu from './SVODSideMenu';

import {
	SVOD_ASSET_NAVIGATION,
	PEACOCK_ADUNIT,
	PEACOCK_ADCHOICE_USER_SELECTION,
	OPT_IN,
	OPT_OUT
} from "./constants";
import { returnTimeInSVOD, returnTargetAssetInfo, isSVODTargetAsset } from '../../functions/utils';
import { TruexAdRenderer } from '@truex/ctv-ad-renderer';

const MAIN_CONTENT = "main_content";
const PRE_ROLL = "pre_roll";
const MID_ROLL = "mid_roll";
const POST_ROLL = "post_roll";

const AD_CHOICE_PEACOCK = false;

class WatchPage extends React.Component {
	constructor(props) {
		super(props);
		this.state = {
			isPlaying: true,
			isFullscreen: false,
			currentStoredTime: 0,
			currentStoredAdTime: 0,
			isTargetAsset: false,
			adBreakIndex: 0,
			currentAdIndex: 0,
			isAdPlayback: false,
			promo_times: this.props.video.promo_insertion_times ? [...this.props.video.promo_insertion_times] : [],
			activeVideoSource: "videoPlayerLayer",
			resumedVideo: false,
			currentPlaybackStage: MAIN_CONTENT,
			displayLoader: true,
			volumeLevel: 100,
			isInfoPanelOpen: false,
			attemptedMoreEpisodes: false,
			attemptedRestart: false,
			displaySkipButton: false,

			// Truex Ad Renderer variables
			adFreePod: false,
			adChoiceOverlay: null,
			adUnitEvent: null
		};

		// peacock's ad choice overlay objects
		this.tarModule;
		this.adChoiceOverLay;
		this.isAdChoiceSVOD = false;

		this.handleAdUnitInit = this.handleAdUnitInit.bind(this);
		this.handleAdEvent = this.handleAdEvent.bind(this);
		this.handleAdError = this.handleAdError.bind(this);
		this.handleClose = this.handleClose.bind(this);
		this.triggerRatingAnimation = this.triggerRatingAnimation.bind(this);
		this.restartVideo = this.restartVideo.bind(this);
		this.attemptMoreEpisodes = this.attemptMoreEpisodes.bind(this);
		this.handleLogout = this.handleLogout.bind(this);
		this.triggerFullscreen = this.triggerFullscreen.bind(this);
		this.videoEnded = this.videoEnded.bind(this);
		this.updateSeekBarTime = this.updateSeekBarTime.bind(this);
		this.play = this.play.bind(this);
		this.pause = this.pause.bind(this);
		this.setPlay = this.setPlay.bind(this);
		this.setPause = this.setPause.bind(this);
		this.displayLoader = this.displayLoader.bind(this);
		this.removeLoader = this.removeLoader.bind(this);
		this.toggleSkipButtonDisplay = this.toggleSkipButtonDisplay.bind(this);
		this.playAdAnimation = this.playAdAnimation.bind(this);
		this.pauseAdAnimation = this.pauseAdAnimation.bind(this);
		this.seek = this.seek.bind(this);
		this.updateVolume = this.updateVolume.bind(this);
		this.skipAd = this.skipAd.bind(this);
		this.checkIsTargetAsset = this.checkIsTargetAsset.bind(this);
		this.handleSkippableContent = this.handleSkippableContent.bind(this);
		this.getPromoAssetsByIndex = this.getPromoAssetsByIndex.bind(this);
		this.toggleInfoPanel = this.toggleInfoPanel.bind(this);
	}

	componentWillMount() {
		if (this.props.environment === EnvType.PEACOCK
			&& isSVODTargetAsset(this.props.video, this.props.targetAssets)
		) {
			// setup the object for the portal player
			Logger.log(this.constructor.name, 'INIT THE AD UNIT COMPONENT');
			this.isAdChoiceSVOD = true;
		}
	}

	componentDidMount() {
		this.props.eventHandler({
			data: {
				event_type: "page_enter",
				asset_name: this.props.video.name,
				asset_id: this.props.video._id,
				page_location: "watch_page",
				time: Date.now()
			}
		});
		this.props.removeDropdown();
	}

	componentDidUpdate(prevProps, prevState) {
		const { svod_env } = this.props.fetchedGroup;
		const isAppleTVGuided = svod_env && svod_env.guided_experience && svod_env.guided_experience.included_appletv_page;
		const isPathedTargetAsset = svod_env && svod_env.guided_experience && svod_env.guided_experience.pathed_target_guide;
		const targetAsset = this.props.targetAssets ? this.props.targetAssets[this.props.targetAssetIndex] : undefined;
		const isCurrentVideoTargetAsset = targetAsset && this.props.video && this.props.video._id === (targetAsset.id || targetAsset._id);

		if (this.props.environment === EnvType.PEACOCK) {
			if (!prevProps.confirmedFinalStep && this.props.confirmedFinalStep) {
				this.play();
			}
		}

		if (this.props.videoProgress.hasOwnProperty(this.props.video._id) && !this.state.resumedVideo) {
			// PORT-222: SVOD Video Resume not working => seek is being called before init_player, so SlavePlayerCore 
			// not initialized and reference is getting undefined. Can comment out for now since not needed for trailer assets.
			// PORT-226: Will be need to be resolved if do study with longer target svod asset.
			// if (this.props.videoProgress[this.props.video._id]) this.seek(this.props.videoProgress[this.props.video._id]);
			// this.setState({ resumedVideo: true });
		}

		if (prevState.currentAdIndex !== this.state.currentAdIndex) {
			if (this[this.state.activeVideoSource]) this[this.state.activeVideoSource].updateVideoPlayer("changeVideo", true, this.props.video);
		}

		if (prevState.activeVideoSource !== "videoPlayerLayer"
			&& this.state.activeVideoSource === "videoPlayerLayer"
		) {
			this.videoPlayerLayer.updateVideoPlayer("forcePlay");
		}

		this.handleSkippableContent(this.state.currentStoredTime);

		if (this.props.beginAppleGuidedExperience
			&& this.props.environment === EnvType.APPLETV
			&& !this.props.promptedTargetAsset
		) {
			let targetAsset = this.props.targetAssets ? this.props.targetAssets[this.props.targetAssetIndex] : undefined;
			let isTargetAsset = targetAsset && this.props.video._id === targetAsset.id;

			if (!isTargetAsset || isAppleTVGuided) {
				let targetAsset = this.props.targetAssets ? this.props.targetAssets[this.props.targetAssetIndex] : undefined;
				let targetAssetName = targetAsset ? targetAsset.name : "";
				if (this.state.isPlaying && !this.props.promptedTargetAsset) this.pause();
				this.props.eventHandler({ data: { event_type: 'apple_prompt_to_target_asset', page_location: "watch_page", targetAsset: targetAssetName, asset_name: this.props.video.name, asset_id: this.props.video._id, } });
			}
		}

		if (!this.state.isTargetAsset) {
			this.checkIsTargetAsset(this.props.video._id, !isPathedTargetAsset);
		}

		if (this.props.forceGuidedExperience
			&& this.props.environment === EnvType.APPLETV
			&& !this.props.promptedForceTargetAsset
		) {
			let targetAsset = this.props.targetAssets ? this.props.targetAssets[this.props.targetAssetIndex] : undefined;
			let isTargetAsset = targetAsset && this.props.video._id === targetAsset.id;

			if (!isTargetAsset || isAppleTVGuided) {
				let targetAsset = this.props.targetAssets ? this.props.targetAssets[this.props.targetAssetIndex] : undefined;
				let targetAssetName = targetAsset ? targetAsset.name : "";
				if (this.state.isPlaying) this.pause();
				this.props.eventHandler({ data: { event_type: 'apple_force_to_target_asset', page_location: "watch_page", targetAsset: targetAssetName } });
			}
		}

		if (this.props.autoNavigateToTargetAsset) {
			const { targetAssetIndex, targetAssets, videos } = this.props;
			const { targetAsset, targetAssetRow } = returnTargetAssetInfo(targetAssetIndex, targetAssets, videos);

			this.props.setSelectedAsset(targetAsset);
			this.props.setSelectedAssetRow(targetAssetRow);

			const targetAssetId = targetAsset ? targetAsset.id || targetAsset._id : "";
			const submittedSVODKey = `${SVOD_ASSET_NAVIGATION}-${targetAssetId}`;
			const submittedAnswer = returnTimeInSVOD(this.props.svodStartTime, this.props.totalModalTime);
			this.props.handleSVODPanelResponses(submittedAnswer, submittedSVODKey, targetAssetId, SVOD_ASSET_NAVIGATION);
		}

		if (this.props.autoNavigateToIncludedAppleTVPage
			|| this.props.autoNavigateToHome
		) {
			let targetAssetId = 'close-page';
			let targetAsset = document.getElementById(targetAssetId);
			if (targetAsset) targetAsset.click();
		}

		if (this.props.promptReturnToHomePage
			&& this.props.environment === EnvType.PEACOCK
			&& !isCurrentVideoTargetAsset
		) {
			this.props.eventHandler({ data: { event_type: 'prompt_return_to_home_page', page_location: "watch_page" } });
		}

		{/*
			NOTE:: Leaving this to test out further functionality and to possibly create functions
			that consolidates its logic
			if (this.props.promptTargetAsset
				&& this.props.environment === EnvType.PEACOCK
				&& !this.props.promptedTargetAsset
				&& !isCurrentVideoTargetAsset
			) {
				let targetAssetName = targetAsset ? targetAsset.name : "";
				this.props.eventHandler({
					data: {
						event_type: 'peacock_prompt_to_target_asset',
						page_location: "watch_page",
						targetAsset: targetAssetName
					}
				});
			}

			if (this.props.promptForcedTargetAsset
				&& this.props.environment === EnvType.PEACOCK
				&& !this.props.promptedForceTargetAsset
				&& !isCurrentVideoTargetAsset
			) {
				let targetAssetName = targetAsset ? targetAsset.name : "";
				this.props.eventHandler({
					data: {
						event_type: 'peacock_force_to_target_asset',
						page_location: "watch_page",
						targetAsset: targetAssetName
					}
				});
			}
		*/}
	}

	componentWillUnmount() {
		const {
			targetPromoAssets,
			videoProgress,
			video,
		} = this.props;

		let newVideoProgressList = videoProgress;
		newVideoProgressList[video._id] = Math.floor(this.state.currentStoredTime);
		this.props.updateVideoProgress(newVideoProgressList);

		let promoAssets = (targetPromoAssets && targetPromoAssets.length && targetPromoAssets.length > this.state.adBreakIndex) ? targetPromoAssets[this.state.adBreakIndex] : [];
		let adBreakIndex = video.currentAdLocation ? video.currentAdLocation.adBreakIndex : this.state.adBreakIndex;
		let currentAdIndex = video.currentAdLocation ? video.currentAdLocation.currentAdIndex + 1 : this.state.currentAdIndex + 1;

		if (currentAdIndex >= promoAssets.length) {
			adBreakIndex += 1;
			currentAdIndex = 0;
		}

		video.currentAdLocation = {
			adBreakIndex,
			currentAdIndex
		};


		this.props.eventHandler({ data: { event_type: "page_exit", asset_name: video.name, asset_id: video._id, page_location: "watch_page", time: Date.now() } });
	}

	async handleAdUnitInit(eventData) {
		let state = { ...this.state };
		let { adChoiceOverlay } = state;
		let adUnitDiv = document.getElementById("ad-unit");
		const { message } = eventData;
		/* SAMPLE eventData
			eventData = {
				service: 'infillion',
				vast_config_url: 'https://get.truex.com/fb53911353a28f585c26a126163ee87abdc45329/vast/config?dimension_1=cc_variation_1'
				message: {
					status: 'display_ads'
				}
			}
		*/
		switch (message.ad_unit.service) {
			case "infillion": {
				// the constant below should be placed in the svod env object and should be dependent of the cell/panelsegment
				// const VAST_CONFIG_URL = "https://stash.truex.com/tests/pilotly/pilotly_reference_implementation.html";
				// const VAST_CONFIG_URL = "https://get.truex.com/fb53911353a28f585c26a126163ee87abdc45329/vast/config?dimension_1=cc_variation_1";
				this.tarModule = new TruexAdRenderer(message.ad_unit.vast_config_url, { supportsUserCancelStream: true });
				this.tarModule.subscribe(this.handleAdEvent);

				await this.tarModule.init()
					.then(vastConfig => {
						this.adChoiceOverLay = this.tarModule.start(vastConfig, adUnitDiv);
						this.setState({ adChoiceEnabled: !!this.adChoiceOverLay });
						Logger.log(this.constructor.name, "handleAdUnitInit() AD CHOICE OVERLAY", this.adChoiceOverLay);
					})
					.then(newAdOverlay => {
						adChoiceOverlay = newAdOverlay;
					})
					.catch(this.handleAdError);
				break;
			}
		}
	}

	handleAdError(errorMessage) {
		Logger.log(this.constructor.name, "handleAdError() AD ERROR", errorMessage);
		if (this.tarModule) {
			// Ensure the ad is no longer blocking back or key events, etc.
			this.tarModule.stop();
		}
	}

	handleAdEvent(event) {
		Logger.log(this.constructor.name, "handleAdEvent() AD EVENT", event);
		const adEvents = this.tarModule.adEvents;
		const { eventHandler, video } = this.props;

		switch (event.type) {
			case adEvents.adError: {
				this.handleAdError(event.errorMessage);
				this.setState({ adChoiceEnabled: false });
				break;
			}
			case adEvents.adStarted: {
				// Choice card loaded and displayed.
				/* USER HAS STARTED THE AD CHOICE COMPONENT */
				eventHandler({
					data: {
						event_type: "ad_unit_started",
						asset_name: video.name,
						asset_id: video._id,
						page_location: "watch_page",
						time: Date.now()
					}
				});
				Logger.log(this.constructor.name, "handleAdEvent() AD EVENT triggered - :", event.type);
				break;
			}
			case adEvents.adDisplayed: {
				/* USER HAS SEEN THE AD CHOICE COMPONENT */
				eventHandler({
					data: {
						event_type: "ad_unit_displayed",
						asset_name: video.name,
						asset_id: video._id,
						page_location: "watch_page",
						time: Date.now()
					}
				});
				break;
			}
			case adEvents.optIn: {
				// User started the engagement experience
				// /* USER HAS OPT IN THE AD CHOICE COMPONENT */
				eventHandler({
					data: {
						event_type: "ad_unit_optin",
						asset_name: video.name,
						asset_id: video._id,
						page_location: "watch_page",
						time: Date.now()
					}
				});
				this.setState({ adUnitEvent: adEvents.optIn }, () => {
					const submitKey = `${PEACOCK_ADUNIT}-${this.props.video._id}`;
					this.props.handleSVODPanelResponses(OPT_IN, submitKey, "", PEACOCK_ADCHOICE_USER_SELECTION);
				});
				break;
			}
			case adEvents.optOut: {
				// User cancelled out of the choice card, either explicitly, or implicitly via a timeout.
				/* USER HAS OPT OUT OF THE AD CHOICE COMPONENT */
				eventHandler({
					data: {
						event_type: "ad_unit_optout",
						asset_name: video.name,
						asset_id: video._id,
						page_location: "watch_page",
						time: Date.now()
					}
				});
				this.setState({ adUnitEvent: adEvents.optOut }, () => {
					const submitKey = `${PEACOCK_ADUNIT}-${this.props.video._id}`;
					this.props.handleSVODPanelResponses(OPT_OUT, submitKey, "", PEACOCK_ADCHOICE_USER_SELECTION);
				});
				break;
			}
			case adEvents.adFreePod: {
				/* USER DID SUFFICIENT INTERACTION FOR AN AD CREDIT */
				break;
			}
			case adEvents.userCancel:
			case adEvents.userCancelStream: {
				// User backed out of the ad, now showing the choice card again.
				eventHandler({
					data: {
						event_type: "ad_unit_cancel",
						asset_name: video.name,
						asset_id: video._id,
						page_location: "watch_page",
						time: Date.now()
					}
				});
				this.setState({ adChoiceEnabled: false });
				break;
			}
			case adEvents.noAdsAvailable: {
				eventHandler({
					data: {
						event_type: "ad_unit_notavailable",
						asset_name: video.name,
						asset_id: video._id,
						page_location: "watch_page",
						time: Date.now()
					}
				});
				break;
			}
			case adEvents.adCompleted: {
				// Ad is not available, or has completed. Depending on the adFreePod flag, either the main
				// video or the ad fallback videos are resumed.
				/* THE USER HAS COMPLETED THE AD CHOICE */
				// if (this[activeVideoSource]) this[activeVideoSource].updateVideoPlayer("forcePlay");

				eventHandler({
					data: {
						event_type: "ad_unit_completed",
						asset_name: video.name,
						asset_id: video._id,
						page_location: "watch_page",
						time: Date.now()
					}
				});
				this.setState({ adChoiceEnabled: false, triggerAdChoiceMethod: true }, () => {
					setTimeout(() => {
						this.setState({ triggerAdChoiceMethod: false });
					}, 250);
				});
				break;
			}
			case adEvents.adFetchCompleted: {
				/* BEGIN CAPTURING INFO ENV RESPONSE */
				break;
			}
		}
	}

	updateVolume(newVolume) {
		if (this[this.state.activeVideoSource]) this[this.state.activeVideoSource].updateVideoPlayer("volume", newVolume);
		this.setState({ volumeLevel: newVolume });
	}

	handleSkippableContent(currentTime) {
		const {
			targetPromoAssets,
			video,
			limitPromosToTargetAsset
		} = this.props;

		const {
			promo_times,
			isTargetAsset,
		} = this.state;

		let flooredTime = Math.floor(currentTime);
		let stage = MAIN_CONTENT;

		if (limitPromosToTargetAsset && !isTargetAsset) {
			return;
		}

		if (this.state.activeVideoSource !== "adPlayerLayer"
			&& promo_times
			&& promo_times.length > 0
			&& promo_times.includes(flooredTime)
			&& targetPromoAssets
			&& targetPromoAssets.length
		) {
			let adBreakIndex = this.props.video.promo_insertion_times.indexOf(flooredTime);
			if (video.currentAdLocation && video.currentAdLocation.adBreakIndex > adBreakIndex) return;

			let promoListUpdateIndex = promo_times.indexOf(flooredTime);
			promo_times.splice(promoListUpdateIndex, 1); //:NOTE:: track which promo is actually in view if someone resumes

			this.videoPlayerLayer.updateVideoPlayer("forcePause");

			if (flooredTime < 1) {
				stage = PRE_ROLL;
			} else if (flooredTime === this.props.video.video.duration) {
				stage = POST_ROLL;
			} else {
				stage = MID_ROLL;
			}

			let promoAssets = (targetPromoAssets && targetPromoAssets.length && targetPromoAssets.length > adBreakIndex) ? targetPromoAssets[adBreakIndex] : [];
			let currentAdIndex = 0;
			if (video.currentAdLocation && adBreakIndex === video.currentAdLocation.adBreakIndex) {
				if (video.currentAdLocation.currentAdIndex < promoAssets.length) {
					currentAdIndex = video.currentAdLocation.currentAdIndex;
				}
			}

			let promoAsset = promoAssets[currentAdIndex];
			this.props.eventHandler({ data: { event_type: "promo_playback", currentPlaybackStage: stage, type: "fullscreen_playback", action: "fullscreen_closed", asset_id: video._id.valueOf(), promo_id: promoAsset ? promoAsset._id : "", time: Date.now() } });

			this.setState({ isAdPlayback: true, currentAdIndex, adBreakIndex, currentPlaybackStage: stage, activeVideoSource: "adPlayerLayer", promo_times, displayLoader: true });
		}

	}

	triggerRatingAnimation() {
		let ratingAnimation = document.querySelector(".rating-animation");
		let font = document.querySelector(".animated-rating-text");
		let line = document.querySelector(".animated-line");

		if (ratingAnimation) ratingAnimation.classList.add("active");
		if (font) font.classList.add("fadein");
		if (line) line.classList.add("expanddown");

		setTimeout(() => {
			if (ratingAnimation) ratingAnimation.classList.remove("active");
		}, 6000);
	}

	handleClose() {
		const {
			currentAdIndex,
			currentPlaybackStage,
			isTargetAsset,
			currentStoredTime,
			currentStoredAdTime,
		} = this.state;

		let currentTime = Date.now();
		let promoAssets = this.getPromoAssetsByIndex();
		let promoAsset = promoAssets[currentAdIndex];

		let promo_id = null;
		if (promoAsset &&
			promoAsset._id
		) {
			promo_id = promoAsset._id;
		}

		this.props.eventHandler({
			data: {
				event_type: "button_click",
				type: "close_watch_page_click",
				current_playback_stage: currentPlaybackStage,
				asset_id: this.props.video._id.valueOf(),
				main_content_timecode: currentStoredTime,
				ad_timecode: currentStoredAdTime,
				promo_id: promo_id,
				page_location: "watch_page",
				time: currentTime
			}
		});

		if (promoAsset && currentPlaybackStage !== MAIN_CONTENT) this.props.eventHandler({ data: { event_type: "complete_promo_playback", currentPlaybackStage, type: "fullscreen_playback", action: "fullscreen_closed", asset_id: this.props.video._id.valueOf(), promo_id: promoAsset._id.valueOf(), timecode: currentStoredAdTime, time: currentTime } });
		if (currentPlaybackStage === POST_ROLL && this.props.environment === EnvType.APPLETV) {
			this.handleLogout();
		}
		else {
			if (isTargetAsset) {
				if (this.props.video && this.props.video.closedVideoPlayerStages) {
					this.props.video.closedVideoPlayerStages.push(currentPlaybackStage);
				} else if (this.props.video) {
					this.props.video.closedVideoPlayerStages = [currentPlaybackStage];
				}

				this.props.closeTargetAsset();
			}

			this.props.eventHandler({ data: { event_type: "close_asset_fullscreen_playback", currentPlaybackStage, type: "fullscreen_playback", action: "fullscreen_closed", asset_id: this.props.video._id.valueOf(), promo_id: promo_id, timecode: currentStoredTime, time: currentTime } });

			if (this.props.environment === EnvType.PEACOCK && isTargetAsset) {
				// In the target asset for Peacock the participant is never routed back to the main page - the watch screen is left by navigating to the exit survey through the logout event.
				this.props.eventHandler({
					data: {
						event_type: "logout",
						completedTargetAsset: true,
						action: "logout",
						time: currentTime
					}
				});
			} else {
				let closeButton = document.getElementById("close-page");
				if (closeButton) closeButton.click();
			}
		}
	}

	handleLogout() {
		if (this.props.environment === EnvType.APPLETV && this.state.isTargetAsset) {
			if (this[this.state.activeVideoSource]) this[this.state.activeVideoSource].updateVideoPlayer("forcePause");
			this.props.eventHandler({ data: { event_type: "logout", asset_name: this.props.video.name, asset_id: this.props.video._id, completedTargetAsset: true, action: "logout", timecode: this.state.currentStoredTime, time: Date.now() } });
		}
	}

	triggerFullscreen() {
		this.props.eventHandler({
			data: {
				event_type: "button_click",
				type: "full_screen_click",
				asset_name: this.props.video.name,
				asset_id: this.props.video._id,
				page_location: "watch_page",
				time: Date.now()
			}
		});
		if (!document.fullscreenElement) {
			document.getElementById('player-container').requestFullscreen();
			this.setState({ isFullscreen: true });
		} else {
			if (document.exitFullscreen) {
				document.exitFullscreen();
				this.setState({ isFullscreen: false });
			}
		}
	}

	videoEnded() {
		const {
			currentAdIndex,
			currentPlaybackStage,
			isTargetAsset,
			currentStoredAdTime,
		} = this.state;
		let currentTime = Date.now();
		let promoAssets = this.getPromoAssetsByIndex();

		if (this.state.isAdPlayback) {
			let promoAsset = promoAssets[currentAdIndex];
			if (promoAsset) this.props.eventHandler({ data: { event_type: "complete_promo_playback", currentPlaybackStage, type: "fullscreen_playback", action: "fullscreen_closed", asset_id: this.props.video._id.valueOf(), promo_id: promoAsset._id, timecode: currentStoredAdTime, time: currentTime } });
			if (currentAdIndex + 1 < promoAssets.length) {
				promoAsset = promoAssets[currentAdIndex + 1];
				this.props.eventHandler({ data: { event_type: "promo_playback", currentPlaybackStage, type: "fullscreen_playback", action: "fullscreen_closed", asset_id: this.props.video._id.valueOf(), promo_id: promoAsset._id, time: currentTime } });
				if (this.props.video && this.props.video.currentAdLocation) this.props.video.currentAdLocation.currentAdIndex = currentAdIndex + 1;
				this.setState({ currentAdIndex: currentAdIndex + 1, displayLoader: true });
			} else if (currentPlaybackStage === POST_ROLL) {
				if (isTargetAsset) {
					setTimeout(() => this.handleLogout(), 500);
				} else {
					setTimeout(() => this.handleClose(), 500);
				}
			} else {
				this.setState({ isAdPlayback: false, activeVideoSource: "videoPlayerLayer", currentPlaybackStage: MAIN_CONTENT, displayLoader: true });
			}
		} else {
			let adBreakIndex = this.props.video.promo_insertion_times ? this.props.video.promo_insertion_times.indexOf(this.props.video.video.duration) : this.state.adBreakIndex;
			if (this.props.video.promo_insertion_times
				&& this.props.video.promo_insertion_times.includes(this.props.video.video.duration)
				&& currentPlaybackStage !== POST_ROLL
				&& this.props.targetPromoAssets[adBreakIndex]
			) {
				this.handleSkippableContent(this.props.video.video.duration);
			} else if (EnvType.APPLETV == this.props.environment && isTargetAsset) {
				this.handleLogout();
			} else {
				setTimeout(() => this.handleClose(), 500);
			}
		}
	}

	updateSeekBarTime(time) {
		if (this.state.isAdPlayback) {
			this.setState({ currentStoredAdTime: time });
		} else {
			this.setState({ currentStoredTime: time });
		}
	}

	toggleInfoPanel() {
		if (this.props.environment === EnvType.APPLETV) {
			if (this.state.isInfoPanelOpen) {
				this.play();
				this.setState({ isInfoPanelOpen: false });
			} else {
				this.pause();
				this.setState({ isInfoPanelOpen: true });
			}
		}
	}

	play() {
		this.props.eventHandler({
			data: {
				event_type: "button_click",
				type: "play_click",
				asset_name: this.props.video.name,
				asset_id: this.props.video._id,
				page_location: "watch_page",
				time: Date.now()
			}
		});
		if (this[this.state.activeVideoSource]) this[this.state.activeVideoSource].updateVideoPlayer("forcePlay");

		this.playAdAnimation();
		this.setState({ isPlaying: true });
	}

	pause() {
		this.props.eventHandler({
			data: {
				event_type: "button_click",
				type: "pause_click",
				asset_name: this.props.video.name,
				asset_id: this.props.video._id,
				page_location: "watch_page",
				time: Date.now()
			}
		});
		if (this[this.state.activeVideoSource]) this[this.state.activeVideoSource].updateVideoPlayer("forcePause");

		this.pauseAdAnimation();
		this.setState({ isPlaying: false });
	}

	setPlay() {
		this.removeLoader();
		this.setState({ isPlaying: true });
	}

	setPause() {
		this.setState({ isPlaying: false });
	}

	pauseAdAnimation() {
		let adAnimation = document.getElementById("progress-circle");
		if (adAnimation) adAnimation.style.animationPlayState = 'paused';
	}

	playAdAnimation() {
		let adAnimation = document.getElementById("progress-circle");
		if (adAnimation) adAnimation.style.animationPlayState = 'running';
	}

	displayLoader() {
		this.pauseAdAnimation();
		this.setState({ displayLoader: true });
	}

	removeLoader() {
		this.playAdAnimation();
		this.setState({ displayLoader: false });
	}

	toggleSkipButtonDisplay(value) {
		this.setState({ displaySkipButton: value });
	}

	seek(time_stamp) {
		if (this[this.state.activeVideoSource]) this[this.state.activeVideoSource].updateVideoPlayer("seek", time_stamp);
		this.displayLoader();
	}

	restartVideo() {
		const {
			currentAdIndex,
			currentPlaybackStage,
			currentStoredTime,
			isTargetAsset
		} = this.state;
		let promoAssets = this.getPromoAssetsByIndex();
		let promoAsset = promoAssets && promoAssets.length ? promoAssets[currentAdIndex] : [];

		this.props.eventHandler({
			data: {
				event_type: "button_click",
				type: isTargetAsset ? "attempted_restart_episode" : "restart_episode",
				asset_name: this.props.video.name,
				asset_id: this.props.video._id,
				promo_id: promoAsset._id,
				page_location: "watch_page",
				timecode: currentStoredTime,
				currentPlaybackStage,
				time: Date.now()
			}
		});
		if (isTargetAsset) {
			this.setState({ attemptedRestart: true });
		} else {
			this.seek(0);
			this.setState({ isInfoPanelOpen: false });
		}
	}

	attemptMoreEpisodes() {
		const {
			currentAdIndex,
			currentPlaybackStage,
			currentStoredTime
		} = this.state;
		let promoAssets = this.getPromoAssetsByIndex();
		let promoAsset = promoAssets && promoAssets.length ? promoAssets[currentAdIndex] : [];

		this.props.eventHandler({
			data: {
				event_type: "button_click",
				type: "more_episodes",
				asset_name: this.props.video.name,
				asset_id: this.props.video._id,
				promo_id: promoAsset._id,
				page_location: "watch_page",
				timecode: currentStoredTime,
				currentPlaybackStage,
				time: Date.now()
			}
		});

		this.setState({ attemptedMoreEpisodes: true });
	}

	skipAd() {
		const {
			currentAdIndex,
			currentPlaybackStage,
			currentStoredAdTime,
		} = this.state;
		let currentTime = Date.now();
		let promoAssets = this.getPromoAssetsByIndex();
		let promoAsset = promoAssets && promoAssets.length ? promoAssets[currentAdIndex] : [];

		this.props.eventHandler({
			data: {
				event_type: "button_click",
				type: "skip_click",
				asset_name: this.props.video.name,
				asset_id: this.props.video._id,
				promo_id: promoAsset._id,
				page_location: "watch_page",
				timecode: this.state.currentStoredAdTime, // time since promo started
				time: currentTime
			}
		});

		if (promoAsset) this.props.eventHandler({ data: { event_type: "complete_promo_playback", currentPlaybackStage, type: "fullscreen_playback", action: "fullscreen_closed", asset_id: this.props.video._id.valueOf(), promo_id: promoAsset._id.valueOf(), timecode: currentStoredAdTime, time: currentTime } });
		if (currentAdIndex + 1 < promoAssets.length) {
			promoAsset = promoAssets[currentAdIndex + 1];
			this.props.eventHandler({ data: { event_type: "promo_playback", currentPlaybackStage, type: "fullscreen_playback", action: "fullscreen_closed", asset_id: this.props.video._id.valueOf(), promo_id: promoAsset._id.valueOf(), time: currentTime } });
			if (this.props.video && this.props.video.currentAdLocation) this.props.video.currentAdLocation.currentAdIndex = currentAdIndex + 1;
			this.setState({ currentAdIndex: currentAdIndex + 1, displayLoader: true, displaySkipButton: false });
		} else {
			this.setState({ isAdPlayback: false, currentPlaybackStage: MAIN_CONTENT, activeVideoSource: "videoPlayerLayer", displayLoader: true, displaySkipButton: false });
		}
	}

	checkIsTargetAsset(videoId, isEnvironmentTargetAsset) {
		// checking if the peacock asset is a target asset based off question paths, selected by the user
		if (this.props.environment === EnvType.PEACOCK
			&& !isEnvironmentTargetAsset
		) {
			let rowTitle;
			if (this.props.selectedAssetRow) {
				rowTitle = (this.props.selectedAssetRow.split("_")[0] === "Poster") ? (this.props.selectedAssetRow.split("_")[2]) : (this.props.selectedAssetRow.split("_")[0]);
			}
			let targetPaths;
			this.props.rowInformation.forEach((row) => {
				if (row.label === rowTitle) {
					targetPaths = row.paths;
				}
			});

			if (targetPaths && targetPaths[videoId]) {
				let possibleTargetPaths = targetPaths[videoId];
				possibleTargetPaths.forEach((conditions) => {
					if (conditions.length) {
						let selectedPaths = [];

						conditions.forEach((path_id) => {
							if (this.props.pathTracker && this.props.pathTracker.includes(path_id)) {
								selectedPaths.push(path_id);
							}
						});

						if (selectedPaths.length === conditions.length) {
							this.setState({ isTargetAsset: true });
						}
					}
				});
			}
		}
		else if (
			this.props.environment === EnvType.APPLETV
			|| (this.props.environment === EnvType.PEACOCK && isEnvironmentTargetAsset)
		) {
			let targetAsset = this.props.targetAssets ? this.props.targetAssets[this.props.targetAssetIndex] : undefined;
			let isTargetAsset = targetAsset && (this.props.video._id === targetAsset.id || this.props.video._id === targetAsset._id);
			if (isTargetAsset) this.setState({ isTargetAsset: true });
		}
	}

	getPromoAssetsByIndex() {
		const {
			targetPromoAssets
		} = this.props;
		const {
			adBreakIndex,
		} = this.state;

		let promoAssets = targetPromoAssets && targetPromoAssets.length ? targetPromoAssets[adBreakIndex] : [];
		return promoAssets;
	}

	render() {
		const {
			video,
			environment,
			isSurveyActive,
			skipButtonInfo,
			fetchedGroup,
			targetParams
		} = this.props;

		let mainAsset = video;
		const { svod_env } = fetchedGroup;

		const {
			adChoiceEnabled,
			currentStoredTime,
			currentStoredAdTime,
			isTargetAsset,
			isAdPlayback,
			currentAdIndex,
			currentPlaybackStage,
			displayLoader
		} = this.state;

		if (this.props.autoNavigateToTargetAsset) {
			return <Redirect to="/study/showpage" />;
		}

		const isSeekEnabled = targetParams && targetParams.test && targetParams.test == '1';
		let promoAssets = this.getPromoAssetsByIndex();
		let promoAsset = promoAssets && promoAssets.length ? promoAssets[currentAdIndex] : [];

		let videoPlayerLayer = (!isSurveyActive) ? (
			<VideoPlayer
				{...this.props}
				isAdPlayerLayer={false}
				isAdPlayback={isAdPlayback}
				location="FSVIDEO"
				playerType={PlayerType.mainContentPlayer}
				sizingMode="FULLSCREEN"
				id="watch-video"
				onRef={ref => this.videoPlayerLayer = ref}
				isPlaying={this.state.isPlaying}
				volumeLevel={this.state.volumeLevel}
				video={mainAsset}
				isSeekEnabled={isSeekEnabled}
				watchpage={true}
				svod_id={this.isAdChoiceSVOD ? svod_env._id : null}
				adChoiceEnabled={this.isAdChoiceSVOD}
				adUnitEvent={this.state.adUnitEvent}
				triggerAdChoiceMethod={this.state.triggerAdChoiceMethod}

				handleAdUnitInit={svod_env.ad_units ? this.handleAdUnitInit : null}
				videoEnded={this.videoEnded}
				updateSeekBarTime={this.updateSeekBarTime}
				playerControlsPause={this.pause}
				playerControlsPlay={this.play}
				setPlay={this.setPlay}
				setPause={this.setPause}
				displayLoader={this.displayLoader}
				removeLoader={this.removeLoader}
				triggerRatingAnimation={this.triggerRatingAnimation}
			/>
		) : "";
		let adPlayerLayer = (!isSurveyActive && isAdPlayback) ? (
			<VideoPlayer
				isAdPlayerLayer={true}
				isAdPlayback={isAdPlayback}
				playerType={PlayerType.adPlayer}
				location="FSVIDEO"
				sizingMode="FULLSCREEN"
				id="watch-video"
				onRef={ref => this.adPlayerLayer = ref}
				isPlaying={this.state.isPlaying}
				volumeLevel={this.state.volumeLevel}
				videoEnded={this.videoEnded}
				updateSeekBarTime={this.updateSeekBarTime}
				playerControlsPause={this.pause}
				playerControlsPlay={this.play}
				setPlay={this.setPlay}
				setPause={this.setPause}
				displayLoader={this.displayLoader}
				removeLoader={this.removeLoader}
				triggerRatingAnimation={this.triggerRatingAnimation}
				promoAsset={promoAsset}
				isSeekEnabled={isSeekEnabled}
				watchpage={true}
				{...this.props}
			/>
		) : "";

		let controlsLayer = (
			<Link id="close-page" to="/study" >
				<div className="watch-arrow" onClick={this.handleClose}><i className="fas fa-arrow-left"></i></div>
			</Link>
		);

		let displayCloseButton = true;
		if ((video.closedVideoPlayerStages &&
			(video.closedVideoPlayerStages.includes(currentPlaybackStage) ||
				(currentPlaybackStage === MAIN_CONTENT && video.closedVideoPlayerStages.includes(MID_ROLL)) ||
				(currentPlaybackStage === MID_ROLL && video.closedVideoPlayerStages.includes(MAIN_CONTENT))
			)) ||
			(
				currentPlaybackStage === PRE_ROLL && skipButtonInfo && !skipButtonInfo.show_exit_during_promo
			)
		) {
			displayCloseButton = false;
		}

		let infoPanel = (
			<div className={`info-panel ${this.state.isInfoPanelOpen ? "active" : ""}`}>
				<div className="info-button" onClick={this.toggleInfoPanel}>
					<img src={appleExitImg} />
					<p>{this.props.intl.formatMessage(svodMessages.info)}</p>
				</div>

				<div className="panel">
					<img className="thumbnail-pic" src={video.images.thumbnail} />
					<div className="text-info">
						<div className="title" >{video.content.title ? video.content.title : ""}</div>
						<div className="logline" >{video.content.description ? video.content.description : ""}</div>
						<div className="meta-tags">
							<span className="dim-text">{video.content.genres ? video.content.genres[0] : ""}</span>
							<span className="dim-text">{convertToMinutes(video.video.duration)}</span>
							<span className="index-rating">{video.content.mpaa.label}</span>

							{video.content.extra_metadata && video.content.extra_metadata.dolby_atmos && (
								<img className="dolby-img" src={dolby_atmos}></img>
							)}
							{video.content.extra_metadata && video.content.extra_metadata.dolby_vision && (
								<img className="dolby-img" src={dolby_vision}></img>
							)}
							{video.video && video.video.captions && video.video.captions.length > 0 && (
								<span className="black-border-icon">{this.props.intl.formatMessage(svodMessages.cc)}</span>
							)}
							{video.content && video.content.extra_metadata && video.content.extra_metadata.sdh && (
								<span className="black-border-icon">{this.props.intl.formatMessage(svodMessages.sdh)}</span>
							)}
							{video.content && video.content.extra_metadata && video.content.extra_metadata.ad && (
								<span className="black-border-icon">{this.props.intl.formatMessage(svodMessages.ad)}</span>
							)}
						</div>
					</div>

					<div className="info-panel-buttons">
						<button className="info-panel-button restart-button" onClick={this.restartVideo}>
							<i className="fas fa-play fa-fw" />
							{this.props.intl.formatMessage(svodMessages.from_beginning)}
							<span className={`tooltip ${this.state.attemptedRestart ? "active" : ""}`}>{this.props.intl.formatMessage(svodMessages.not_available)}</span>
						</button>
						<button className="info-panel-button more-like-this" onClick={this.attemptMoreEpisodes}>
							{this.props.intl.formatMessage(svodMessages.more_episodes)}
							<span className={`tooltip ${this.state.attemptedMoreEpisodes ? "active" : ""}`}>{this.props.intl.formatMessage(svodMessages.not_available)}</span>
						</button>
					</div>

				</div>
			</div>
		);

		let ratingText = video && video.content && video.content.mpaa && video.content.mpaa.label ? video.content.mpaa.label.split("-")[1] : null;

		switch (environment) {
			case EnvType.PEACOCK: {
				controlsLayer = (
					<div className="video-control-panel">
						{!isTargetAsset && (
							<Link id="close-page" to="/study/showpage" >
								<div className="watch-arrow peacock-icon" onClick={this.handleClose}>X</div>
							</Link>
						)}

						<PlayerControls
							currentStoredTime={isAdPlayback ? currentStoredAdTime : currentStoredTime}
							isPlaying={this.state.isPlaying}
							isAdPlayback={isAdPlayback ? true : false}
							isFullscreen={this.state.isFullscreen}
							volumeLevel={this.state.volumeLevel}
							mainAsset={mainAsset}
							promoAsset={promoAsset}
							currentPlaybackStage={currentPlaybackStage}
							play={this.play}
							pause={this.pause}
							seek={this.seek}
							skipAd={this.skipAd}
							pauseAdAnimation={this.pauseAdAnimation}
							playAdAnimation={this.playAdAnimation}
							updateVolume={this.updateVolume}
							toggleInfoPanel={this.toggleInfoPanel}
							triggerFullscreen={this.triggerFullscreen}
							isOutro={currentPlaybackStage === POST_ROLL}
							{...this.props}
						/>

						<div className="peacock-extra-player-buttons">
							<div className="fullscreen peacock-icon" onClick={this.triggerFullscreen}><i className="fas fa-expand"></i></div>
							{!isAdPlayback && !isTargetAsset && (
								<Link to="/study/showpage" >
									<div className="more-episodes peacock-icon" onClick={this.handleClose}>{this.props.intl.formatMessage(svodMessages.more_episodes)}</div>
								</Link>
							)}
						</div>
					</div>
				);
				break;
			}
			case EnvType.APPLETV: {
				controlsLayer = (
					<div className="appletv-video-controls video-control-panel">
						<div className="video-click-block"></div>
						{displayCloseButton && (
							<Link id="close-page" to="/study/showpage" >
								<div className="watch-arrow" onClick={this.handleClose}><img src={appleExitImg} /></div>
							</Link>
						)}

						{ratingText && (
							<div className="rating-animation">
								<span className="animated-rating-text">
									<div>TV</div>
									<div>{ratingText}</div>
								</span>
								<span className="animated-line">

								</span>
							</div>
						)}

						<PlayerControls
							currentStoredTime={isAdPlayback ? currentStoredAdTime : currentStoredTime}
							isPlaying={this.state.isPlaying}
							isAdPlayback={isAdPlayback ? true : false}
							isFullscreen={this.state.isFullscreen}
							volumeLevel={this.state.volumeLevel}
							isTargetAsset={isTargetAsset}
							mainAsset={mainAsset}
							promoAsset={promoAsset}
							currentPlaybackStage={currentPlaybackStage}
							displaySkipButton={this.state.displaySkipButton}
							play={this.play}
							pause={this.pause}
							seek={this.seek}
							toggleSkipButtonDisplay={this.toggleSkipButtonDisplay}
							pauseAdAnimation={this.pauseAdAnimation}
							playAdAnimation={this.playAdAnimation}
							updateVolume={this.updateVolume}
							triggerFullscreen={this.triggerFullscreen}
							toggleInfoPanel={this.toggleInfoPanel}
							isOutro={currentPlaybackStage === POST_ROLL}
							{...this.props}
						/>
					</div>
				);
				break;
			}
		}

		return (
			<div className="watch-page" id="player-container">
				<div id="ad-unit" className={`ad-choice-display ${adChoiceEnabled ? "enabled" : ""}`}></div>
				<SVODSideMenu {...this.props} addedClasses="opacity-0p z-index-0 menu-hidden" page="show_page" profileIconOnly={true} />

				{this.state.isInfoPanelOpen && infoPanel}
				{!this.state.isInfoPanelOpen && controlsLayer}
				{adPlayerLayer}
				{videoPlayerLayer}
				{this.state.displaySkipButton
					&& (currentPlaybackStage !== POST_ROLL)
					&& (
						<button className="skip-button" onClick={this.skipAd}>{this.props.intl.formatMessage(svodMessages.skip_intro)}</button>
					)}
				<img className={`loading-circle ${displayLoader ? "" : "hidden"}`} src={loading}></img>
			</div>
		);
	}
}


const mapStateToProps = (state, ownProps) => ({
	volume: state.SVOD.volume,
	appleTVVideos: state.SVOD.appleTVVideos,
	isSurveyActive: state.SVOD.isSurveyActive,
	environment: state.SVOD.environment,
	videoProgress: state.SVOD.videoProgress,
	video: state.SVOD.selectedAssets.asset,
	videos: state.SVOD.videos,
	globalAnalyticsAdapter: state.GlobalAnalyticsAdapterReducer.globalAnalyticsAdapter,
	rowInformation: state.targetProcess.fetchedGroup.svod_env.rows,
	selectedAssetRow: state.SVOD.selectedAssets.assetRow,
	skipButtonInfo: state.targetProcess.fetchedGroup.svod_env.skip_button,
	targetPromoAssets: state.targetProcess.fetchedGroup.svod_env.target_promo_assets,
	limitPromosToTargetAsset: state.targetProcess.fetchedGroup.svod_env.limit_promos_to_target_asset,
	targetAssets: state.targetProcess.fetchedGroup.svod_env.target_assets,
	closedTargetAsset: state.SVOD.closedTargetAsset,
});

const mapDispatchToProps = (dispatch, ownProps) => ({
	removeDropdown: () => dispatch(removeDropdown()),
	updateVideoProgress: (newVideoProgressList) => dispatch(updateVideoProgress(newVideoProgressList)),
	setSelectedAsset: (asset) => dispatch(setSelectedAsset(asset)),
	setSelectedAssetRow: (label) => dispatch(setSelectedAssetRow(label)),
	closeTargetAsset: () => dispatch(closeTargetAsset()),
	eventHandler: ownProps.eventHandler,
});

export default connect(mapStateToProps, mapDispatchToProps)(injectIntl(WatchPage));


// WEBPACK FOOTER //
// ./src/components/svod/watch-page.jsx